import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';

import { ButtonModule, DIALOG_DATA, DialogRef } from '@hglobal/fin-ui';

import { VaultNetworkSwitchDialogData, VaultNetworkSwitchDialogResult } from './vault-network-switch-dialog.model';

@Component({
  selector: 'drf-vault-network-switch-dialog',
  imports: [ButtonModule],
  templateUrl: './vault-network-switch-dialog.component.html',
  styleUrl: './vault-network-switch-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultNetworkSwitchDialogComponent {
  readonly #dialogRef = inject(DialogRef);

  readonly data = inject(DIALOG_DATA) as unknown as VaultNetworkSwitchDialogData;

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.cancel();
  }

  confirm(): void {
    this.#dialogRef.close(VaultNetworkSwitchDialogResult.Confirm);
  }

  cancel(): void {
    this.#dialogRef.close(VaultNetworkSwitchDialogResult.Cancel);
  }
}
